import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./app_dashboard_card.css";
import { ReactComponent as SubmissionIcon } from "../../../Submitted.svg";
import { ReactComponent as PendingReviewIcon } from "../../../PendingReview.svg";
import { ReactComponent as PendingSubmissionIcon } from "../../../PendingSubmission.svg";
import { ReactComponent as DraftIcon } from "../../../Draft.svg";
import { ReactComponent as ProposalProceeededIcon } from "../../../ProposalProceeeded.svg";
import { ReactComponent as QuotationCreatedIcon } from "../../../QuotationCreated.svg";
import Config from "../../../Config";

class AppDashboardCard extends Component {
    constructor(props) {
        super(props);
    }

    getStatus() {
        let quotationStatus = ''
        this.props.status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED' :
            this.props.status === 'Quotation Created' ? quotationStatus = 'PENDING' :
                this.props.status === 'Draft' ? quotationStatus = 'DRAFT' :
                    quotationStatus = this.props.status;

        return quotationStatus;
    }

    render() {
        return (
            <div className="dashboard__card p-3 " onClick={()=> this.props.onClick()}>
                <div className="dashboard__card_title w-100">
                    {Config[this.props.module ? this.props.module : 'proposal'].statusMapping[this.getStatus()].display}
                </div>
                <div className="mt-2 d-flex ">
                    <div className="p-0 m-0">
                        <div
                            className="py-1 px-2 align-content-center"
                            style={{
                                backgroundColor: `${Config[this.props.module].statusMapping[this.getStatus()].backgroundColor}`,
                                textAlign: 'center',
                                height: '40px',
                                width: '40px'
                            }}
                        >

                            {
                                this.props.status === 'SUBMITTED' ?
                                    <SubmissionIcon className="dashboard__icon" /> :
                                    this.props.status === "PENDING" ?
                                        <PendingSubmissionIcon className="dashboard__icon" /> :
                                        this.props.status === "INITIATED" ?
                                            <PendingReviewIcon className="dashboard__icon" /> :
                                            this.props.status === "GENERATED" ?
                                                <ProposalProceeededIcon className="dashboard__icon" /> :
                                                <DraftIcon className="dashboard__icon" />
                            }
                        </div>


                    </div>
                    <div className="ml-2 p-1 dashboard__card_value_container dashboard__card_text">
                        {this.props.cardValue}
                    </div>
                </div>

            </div>
        )
    }
}
export default withRouter(AppDashboardCard);